export const actions = {
  GET_SINGLE_EMOJI: "GET_SINGLE_EMOJI",
  GET_MULTIPLE_EMOJI: "GET_MULTIPLE_EMOJI",
  CHANGE_EMOTION: "CHANGE_EMOTION",
  TOGGLE_LOCK: "TOGGLE_LOCK"
};
